import { render, staticRenderFns } from "./confirmSubmit.vue?vue&type=template&id=6d0ade85&scoped=true&"
import script from "./confirmSubmit.vue?vue&type=script&lang=js&"
export * from "./confirmSubmit.vue?vue&type=script&lang=js&"
import style0 from "./confirmSubmit.vue?vue&type=style&index=0&id=6d0ade85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ade85",
  null
  
)

export default component.exports